<div class="audit-page">
  <div class="audit-card-shell">

    <header class="audit-header">
      <h1 class="audit-header__title">Audit Trail</h1>

      <div class="audit-header__actions">
        <mat-form-field appearance="outline" class="audit-header__date-range">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="MM/DD/YYYY" [(ngModel)]="fromDate" (dateChange)="onDateRangeChange()" />
            <input matEndDate placeholder="MM/DD/YYYY" [(ngModel)]="toDate" (dateChange)="onDateRangeChange()" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker></mat-date-range-picker>
        </mat-form-field>

        <button
          type="button"
          class="audit-header__close"
          aria-label="Clear date filter"
          matTooltip="Clear date filter"
          matTooltipPosition="below"
          [disabled]="!hasDateFilter"
          (click)="clearDateFilter()">
          <span class="material-icons">close</span>
        </button>
      </div>
    </header>

    <div *ngIf="isLoading" class="audit-loading">
      <mat-progress-spinner mode="indeterminate" [diameter]="36" [strokeWidth]="3"></mat-progress-spinner>
    </div>

    <div class="audit-list" *ngIf="!isLoading">

      <div *ngIf="rows.length === 0" class="audit-empty">
        No kill switch activity for the selected range.
      </div>

      <div
        *ngFor="let row of rows; let i = index"
        class="audit-card"
        [class.audit-card--expanded]="expandedIndex === i">

        <div class="audit-card__row" (click)="toggleExpand(i)">
          <div class="audit-card__col">
            <span class="audit-card__label">Updated By</span>
            <span class="audit-card__value">{{ row.userDisplayName || row.updatedBy || '-' }}</span>
          </div>

          <div class="audit-card__col">
            <span class="audit-card__label">Updated At</span>
            <span class="audit-card__value">{{ formatTimestamp(row.updatedAt) }}</span>
          </div>

          <div class="audit-card__col">
            <span class="audit-card__label">Pool Name</span>
            <span class="audit-card__value">{{ row.poolName || '-' }}</span>
          </div>

          <div class="audit-card__col">
            <span class="audit-card__label">Switch Type</span>
            <span
              class="audit-card__chip"
              [class.audit-card__chip--master]="row.switchType === 'Master'"
              [class.audit-card__chip--pool]="row.switchType === 'Pool'">
              {{ switchTypeLabel(row.switchType) }}
            </span>
          </div>

          <button type="button" class="audit-card__chevron" aria-label="Toggle details" (click)="toggleExpand(i); $event.stopPropagation()">
            <span class="material-icons">{{ expandedIndex === i ? 'expand_less' : 'expand_more' }}</span>
          </button>
        </div>

        <div class="audit-card__details" *ngIf="expandedIndex === i">
          <div class="audit-card__details-col">
            <div class="audit-card__details-title">Past Activity</div>
            <div class="audit-card__state-row">
              <span class="audit-card__state-label">State</span>
              <strong class="audit-card__state-value">{{ stateLabel(row.previousState) }}</strong>
            </div>
          </div>

          <div class="audit-card__details-col">
            <div class="audit-card__details-title">Recent Activity</div>
            <div class="audit-card__state-row">
              <span class="audit-card__state-label">State</span>
              <strong class="audit-card__state-value">{{ stateLabel(row.recentState) }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      [length]="totalCount"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50]"
      (page)="onPageChange($event)"
      aria-label="Select page">
    </mat-paginator>

  </div>
</div>
